module.exports = "canvas {\n    width: 100%;\n    height: 100%;\n}\nimg {\n    /** TODO: stephen figure out why we have to reset the max-width to get this to appear... **/\n    max-width: inherit;\n    min-width: 20px;\n    height: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/assessment-charts/legend-color-icon/legend-color-icon.component.css
// module id = ./src/app/assessment-charts/legend-color-icon/legend-color-icon.component.css
// module chunks = main